/** Scroll to hash target, open parent <details> if any, set focus, sync location.hash. */
export default function honourFragmentIdLinks(routerLocation) {
  if (!routerLocation?.hash) return;
  const id = routerLocation.hash.replace("#", "");
  const fragment = document.querySelector(`[id='${id}']`);
  if (!fragment) return;

  const detailsParent = fragment.closest("details");
  if (detailsParent) {
    detailsParent.setAttribute("open", "");
  }

  fragment.tabIndex = "-1";
  fragment.focus();
  fragment.scrollIntoView({
    behavior: "auto",
    block: "center",
  });

  window.location.hash = routerLocation.hash;
}
